(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-product-tile] a[href*="/products/"]');
    if (!link) return;

    var tile = link.closest('[data-product-tile]');
    if (!tile) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_name: tile.dataset.itemListName,
        items: [
          {
            item_id: tile.dataset.itemId,
            item_name: tile.dataset.itemName,
            currency: tile.dataset.itemCurrency,
            price: parseFloat(tile.dataset.itemPrice),
            item_category: tile.dataset.itemCategory,
            index: parseInt(tile.dataset.itemIndex, 10),
          },
        ],
      },
    });
  });
})();
